import DropDown from "./components/Dropdown.vue";
import { ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import OtpInput from "@bachdgvn/vue-otp-input";
import {
  MultiSelectComponent,
  MultiSelectPlugin
} from "@syncfusion/ej2-vue-dropdowns";

import { ValidationField, ValidationForm } from "@/components/Base/Form";
import CommonModal from "@/components/Base/CommonModal";
import IsisAutocomplete from "@/components/Base/IsisAutocomplete";
import IsisTimePicker from "@/components/Base/IsisTimePicker";
import IsisDatepicker from "@/components/Base/IsisDatepicker";
import IsisDateTimePicker from "./components/Base/IsisDateTimePicker";
import DateRangePicker from "./components/Base/Vue2DatePicker/DateRangePicker";
import DateTimePicker from "./components/Base/Vue2DatePicker/DateTimePicker";
import DatePickerCustom from "./components/Base/Vue2DatePicker/DatePicker";
import NoDataFound from "./components/Base/Illustration/NoDataFound";
import NoResult from "./components/Base/Illustration/NoResult";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
    Vue.component("v-otp-input", OtpInput);
    Vue.component(MultiSelectPlugin.name, MultiSelectComponent);
    Vue.component(ValidationField.name, ValidationField);
    Vue.component(ValidationForm.name, ValidationForm);
    Vue.component(CommonModal.name, CommonModal);
    Vue.component(IsisAutocomplete.name, IsisAutocomplete);
    Vue.component(IsisTimePicker.name, IsisTimePicker);
    Vue.component("isisDatepicker", IsisDatepicker);
    Vue.component("IsisDateTimepicker", IsisDateTimePicker);
    Vue.component("dateRangePicker", DateRangePicker);
    Vue.component("dateTimePicker", DateTimePicker);
    Vue.component("datePickerCustom", DatePickerCustom);
    Vue.component("NoDataFound", NoDataFound);
    Vue.component("NoResult", NoResult);
  }
};

export default GlobalComponents;
